import React from 'react';
import RootNavigation from '@routes/RootNavigation';

const App = () => {
  return <RootNavigation />;
};

export default App;
